<section [attr.data-theme]="theme()" class="tabs-wrapper">
  @for (option of options(); track $index) {
    <button
      (click)="value.set(option.value)"
      [attr.data-theme]="theme()"
      [class.active]="value() === option.value"
      class="tab"
    >
      @if (option.icon) {
        <app-icon
          [attr.data-theme]="theme()"
          size="sm"
          [name]="option.icon"
          class="theme-text"
        />
      }
      <p [attr.data-theme]="theme()" class="text-sm font-semibold theme-text">
        {{ option.label }}
      </p>
    </button>
  }
</section>
